import React from "react";
import { useParams } from "hooks/useParams";

export const CheckoutRedirectSuccessPage: React.FC = () => {
    const { session_id: sessionId } = useParams();
    const deepLinkBase =
        "switcherstudioreturnapi://dashboard.switcherstudio.com/checkout_redirect/success";
    const deepLink = sessionId
        ? `${deepLinkBase}?session_id=${encodeURIComponent(sessionId)}`
        : deepLinkBase;

    return (
        <a
            className="m-auto d-flex justify-content-center btn btn-primary btn-block btn-lg"
            href={deepLink}
        >
            Return to Switcher
        </a>
    );
};
